import React from 'react';
import { useFeatureNav } from '../../hooks/useFeatureNav';
import { ListChecks } from 'lucide-react';
import OnboardingFlow from './OnboardingFlow';

// Top-level "Onboarding" page for participants — the voice-first Orbit check-in
// (same flow that's a tab in the AAI workspace for other roles).
const OnboardingPage: React.FC = () => {
  const { go } = useFeatureNav();
  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex items-center gap-2 mb-1">
        <ListChecks size={22} className="text-brand-500" />
        <h1 className="text-2xl font-semibold text-gray-900">Onboarding</h1>
      </div>
      <p className="text-sm text-gray-500 mb-6">A quick voice check-in with Orbit to map where you are.</p>
      <OnboardingFlow onCompleted={() => go('/my-readiness')} />
    </div>
  );
};

export default OnboardingPage;
